import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { extendTailwindMerge } from 'tailwind-merge';
const twMerge = extendTailwindMerge({
    prefix: 'nucleus-',
});
const CardHeader = (_a) => {
    var { children, className = '' } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: twMerge('nucleus-box-border nucleus-border-x-0 nucleus-px-4 nucleus-py-5 sm:nucleus-px-6', className) }, rest, { children: children })));
};
const CardContent = (_a) => {
    var { children, className = '' } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: twMerge('nucleus-box-border nucleus-border-x-0 nucleus-px-4 nucleus-py-5 sm:nucleus-p-6', className) }, rest, { children: children })));
};
const CardFooter = (_a) => {
    var { children, className = '' } = _a, rest = __rest(_a, ["children", "className"]);
    return (_jsx("div", Object.assign({ className: twMerge('nucleus-box-border nucleus-border-x-0 nucleus-px-4 nucleus-py-4 sm:nucleus-px-6', className) }, rest, { children: children })));
};
const Card = (_a) => {
    var { children, className = '', style } = _a, rest = __rest(_a, ["children", "className", "style"]);
    return (_jsx("div", Object.assign({ className: twMerge('nucleus-font-sans nucleus-box-border nucleus-text-text-primary nucleus-divide-y nucleus-divide-solid nucleus-divide-neutral-200 dark:nucleus-divide-neutral-300 nucleus-overflow-hidden nucleus-rounded-lg nucleus-border nucleus-border-solid nucleus-border-neutral-200 dark:nucleus-border-neutral-300 nucleus-bg-background dark:nucleus-bg-surface nucleus-shadow', className), 
        // The card already has an explicit border, so the hairline white ring
        // baked into the default shadow (visible only in dark mode) doubles up as
        // a second outline. Zero it out here while keeping the soft drop shadow.
        style: Object.assign({ ['--shadow-ring-strength']: 0 }, style) }, rest, { children: children })));
};
Card.Header = CardHeader;
Card.Content = CardContent;
Card.Footer = CardFooter;
export { Card };
//# sourceMappingURL=card.component.js.map